/*
 * goldlip-mobile-init.js
 * Sticky ATC bar visibility on mobile via IntersectionObserver.
 * Hides bar when real ATC button is visible; shows when scrolled past.
 */
(function () {
  if (window.innerWidth > 768) return;
  if (!window.IntersectionObserver) {
    // No IntersectionObserver support — just let Minimog handle it
    return;
  }

  function init() {
    // Try multiple selectors for the main ATC button
    var atcBtn =
      document.querySelector('.m-product-form button[name="add"]') ||
      document.querySelector('.m-product-form .m-add-to-cart') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('.m-add-to-cart');

    var stickyBar = document.querySelector('.m-sticky-addtocart');

    // If no ATC button found, show sticky bar unconditionally
    if (!atcBtn) {
      if (stickyBar) {
        stickyBar.style.transform = '';
        stickyBar.style.pointerEvents = '';
      }
      return;
    }

    // If no sticky bar, nothing to do
    if (!stickyBar) return;

    // Initially hide sticky bar
    stickyBar.style.transform = 'translateY(100%)';
    stickyBar.style.transition = 'transform 0.25s ease';
    stickyBar.style.pointerEvents = 'none';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // ATC button visible — hide sticky bar
            stickyBar.style.transform = 'translateY(100%)';
            stickyBar.style.pointerEvents = 'none';
          } else {
            // ATC button off-screen — show sticky bar
            stickyBar.style.transform = 'translateY(0)';
            stickyBar.style.pointerEvents = '';
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(atcBtn);
  }

  // Run after full page + Minimog JS has loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(init, 600);
    });
  } else {
    setTimeout(init, 600);
  }
})();
